var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinetMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m15.647 12.657-.702 2.161h-2.272a1.42 1.42 0 0 0-.836 2.573l1.838 1.336-.702 2.161a1.421 1.421 0 0 0 2.189 1.59L17 21.143l1.838 1.335a1.421 1.421 0 0 0 2.189-1.59l-.702-2.161 1.838-1.336a1.42 1.42 0 0 0-.836-2.573h-2.272l-.702-2.161a1.423 1.423 0 0 0-2.706 0zm1.353.69.797 2.452a.75.75 0 0 0 .713.519h2.579l-2.086 1.516a.75.75 0 0 0-.273.838l.797 2.453-2.086-1.516a.75.75 0 0 0-.882 0l-2.086 1.516.797-2.453a.75.75 0 0 0-.273-.838l-2.086-1.516h2.579a.75.75 0 0 0 .713-.519L17 13.347z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20.263H2.95a.2.2 0 0 1-.2-.2v-1.45c0-.831.593-1.563 1.507-2.185 1.632-1.114 4.273-1.816 7.243-1.816a.75.75 0 0 0 0-1.5c-3.322 0-6.263.831-8.089 2.076-1.393.95-2.161 2.157-2.161 3.424v1.451a1.7 1.7 0 0 0 1.7 1.7h8.55a.75.75 0 1 0 0-1.5zM11.5 1.25C8.464 1.25 6 3.714 6 6.75s2.464 5.5 5.5 5.5S17 9.786 17 6.75s-2.464-5.5-5.5-5.5zm0 1.5c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinetMaster);
export default __webpack_public_path__ + "static/media/clinet-master.74bf0ae49e18d33db10a6ae61034bacc.svg";
export { ForwardRef as ReactComponent };